import Torus from '@toruslabs/torus-embed';

export default {
  Torus,
};
